import { Location } from "@angular/common";
import { ApiHelperService } from "../../core/api-helper.service";
import { AuthService } from "../../core/auth.service";
import { AuthorizationError, ForbiddenError, NoContentError, OnDialogCloseEnum, SwipesumError } from "../../models/errors/error.model";
import { ErrorDialogService } from "../error-dialog/error-dialog.service";

export class ErrorHandler {
    constructor(
        protected errorDialog: ErrorDialogService,
        protected auth: AuthService,
        protected api: ApiHelperService,
        protected location: Location
    ) { }

    protected logout: () => void;
    protected back: () => void;

    async handle(e: Error, upgradeTo: typeof SwipesumError = SwipesumError) {
        const se: SwipesumError  = upgradeTo.upgrade(e);
        if (se instanceof NoContentError) return;

        await this.api.reportError(se);

        const dialog = this.errorDialog.open(
            se.ctx.userHeader,
            se.ctx.userMessage
        );

        const that = this; //eslint-disable-line
        switch (se.onDialogClose) {
            case OnDialogCloseEnum.LOGOUT: {
                const sub = dialog.subscribe(this.logout ?? (() => {
                    sub.unsubscribe();
                    that.auth.logout();
                }));
            }
            case OnDialogCloseEnum.BACK: {
                const sub = dialog.subscribe(this.back ?? (() => {
                    sub.unsubscribe();
                    that.location.back();
                }));
            }
        }
    }

    async reportAndRethrow(e: Error, rethrow: boolean = true) {
        const se = SwipesumError.upgrade(e);

        if (se instanceof NoContentError) return;

        await this.api.reportError(se);
        se.reported = true;
        if (rethrow) throw se;
    }
}
